module.exports = __webpack_public_path__ + "files/ad16431cadae6c71c6d75957de00df46.png";